import {inject, Injectable, InjectionToken} from '@angular/core';
import {ComponentType} from '@angular/cdk/portal';
import {MatDialog} from '@angular/material/dialog';
import {
    ActivitySearchEngineDialogComponent
} from '@modules/activities/core/activities-search-engine';
import {CommunicationCenterService} from "@modules/communication-center";
import {ActivitySearchEngineConfig} from "@modules/activities/core/activities-search-engine/activity-search-engine.config";

export const ACTIVITY_SEARCH_ENGINE_DIALOG_COMPONENT = new InjectionToken<ComponentType<unknown>>(
    'ACTIVITY_SEARCH_ENGINE_DIALOG_COMPONENT'
);

export const ACTIVITY_SEARCH_ENGINE_DIALOG_PANEL_CLASS = new InjectionToken<string | string[]>(
    'ACTIVITY_SEARCH_ENGINE_DIALOG_PANEL_CLASS'
);

@Injectable({
    providedIn: 'root'
})
export class ActivitiesSearchEngineService {

    public dialog = inject(MatDialog);
    private communicationCenter = inject(CommunicationCenterService);
    private dialogComponent = inject(ACTIVITY_SEARCH_ENGINE_DIALOG_COMPONENT, {optional: true})
        ?? ActivitySearchEngineDialogComponent;
    private dialogPanelClass = inject(ACTIVITY_SEARCH_ENGINE_DIALOG_PANEL_CLASS, {optional: true})
        ?? 'activity-search-engine__dialog';

    public openSearchActivityEngine(config?: ActivitySearchEngineConfig) {
        if (config) {
            this.setConfig(config);
        }
        const searchEngineDialog = this.dialog.open(this.dialogComponent, {
            panelClass: this.dialogPanelClass,
            ariaLabelledBy: 'search-engine-title',
        });
        return searchEngineDialog.afterClosed();
    }

    public setConfig(config: ActivitySearchEngineConfig): void {
        this.communicationCenter
            .getRoom('activity-search-engine')
            .next('config', config);
    }
}
